import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    changePasswordDetails: {},
    loading: false,
    openChangePasswordDetailModal: false,
    error: null,
};

const changePasswordDetailsSlice = createSlice({
    name: 'changePasswordDetails',
    initialState,
    reducers: {
        openChangePasswordModal: (state) => {
            state.openChangePasswordDetailModal = true;
        },
        closeChangePasswordModal: (state) => {
            state.openChangePasswordDetailModal = false;
        },
    },
});


export const { openChangePasswordModal, closeChangePasswordModal } = changePasswordDetailsSlice.actions;
export const changePasswordDetails = changePasswordDetailsSlice.reducer;
